(function () {
  var root = document.getElementById('rh');
  if (!root || root._rh) return;
  root._rh = true;
  var mq = window.matchMedia('(min-width:1025px)');
  var cats = [].slice.call(root.querySelectorAll('[data-rh-cat]'));
  var dds = [].slice.call(root.querySelectorAll('.rh-dd'));
  var openCat = null, tOpen = 0, tClose = 0;

  function load(cat) {
    [].forEach.call(cat.querySelectorAll('img[data-src]'), function (img) {
      img.onload = function () { img.classList.add('is-ld'); };
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      if (img.complete) img.classList.add('is-ld');
    });
  }
  function setCat(cat) {
    if (openCat === cat) return;
    if (openCat) { openCat.classList.remove('is-open'); openCat.querySelector('.rh-nl').setAttribute('aria-expanded', 'false'); }
    openCat = cat;
    if (cat) { load(cat); cat.classList.add('is-open'); cat.querySelector('.rh-nl').setAttribute('aria-expanded', 'true'); closeDD(); }
    root.classList.toggle('is-mega', !!cat);
  }
  function closeDD(except) {
    dds.forEach(function (d) {
      if (d === except) return;
      d.classList.remove('is-open');
      var b = d.querySelector('[aria-expanded]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function openDD(d) {
    closeDD(d);
    setCat(null);
    d.classList.add('is-open');
    var b = d.querySelector('[aria-expanded]');
    if (b) b.setAttribute('aria-expanded', 'true');
  }

  cats.forEach(function (cat) {
    cat.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearTimeout(tClose);
      clearTimeout(tOpen);
      tOpen = setTimeout(function () { setCat(cat); }, openCat ? 0 : 110);
    });
    cat.addEventListener('mouseleave', function () {
      clearTimeout(tOpen);
      tClose = setTimeout(function () { if (openCat === cat) setCat(null); }, 160);
    });
    var link = cat.querySelector('.rh-nl');
    link.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); setCat(cat); var f = cat.querySelector('.rh-mega a'); if (f) f.focus(); }
    });
    cat.addEventListener('focusin', function () { setCat(cat); });
    // dokunmatik masaustu: ilk dokunus paneli acar
    link.addEventListener('touchend', function (e) {
      if (openCat !== cat) { e.preventDefault(); setCat(cat); }
    }, { passive: false });
  });

  dds.forEach(function (d) {
    var b = d.querySelector('button');
    var t = 0;
    d.addEventListener('mouseenter', function () { if (!mq.matches) return; clearTimeout(t); openDD(d); });
    d.addEventListener('mouseleave', function () { t = setTimeout(function () { d.classList.remove('is-open'); if (b) b.setAttribute('aria-expanded', 'false'); }, 180); });
    if (b) b.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.classList.contains('is-open')) closeDD(); else openDD(d);
    });
  });

  root.querySelector('.rh-veil').addEventListener('click', function () { setCat(null); });
  root.addEventListener('focusout', function (e) {
    if (!e.relatedTarget || !root.contains(e.relatedTarget)) { setCat(null); closeDD(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && (openCat || root.querySelector('.rh-dd.is-open'))) {
      var back = openCat ? openCat.querySelector('.rh-nl') : null;
      setCat(null); closeDD();
      if (back) back.focus();
    }
  });
  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) { closeDD(); setCat(null); }
  });

  var ticking = false;
  function onScroll() {
    ticking = false;
    root.classList.toggle('is-scrolled', window.scrollY > 40);
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  // kategori acikken metin seciminde/scrollda kapanmasin; sayfa degisince temizle
  window.addEventListener('pageshow', function () { setCat(null); closeDD(); });
})();
